﻿import { WorkItemDataVersionPreference } from 'runtime/data/workitemdataversionpreference';

export class OpenReadOnlyWorkItemRequested {
    constructor(public workItemId: string, public preference: WorkItemDataVersionPreference, public stepFilter: string, public closeWhenComplete: boolean) { }

    static eventName() { return 'OpenReadOnlyWorkItemRequested'; }

    eventName = OpenReadOnlyWorkItemRequested.eventName;
}